import { ResponseError } from 'shared/errors';

interface IParams {
  message?: string;
  errors?: object[];
}

export const assertResponseError = (domain: string, { message, errors }: IParams) => {
  return new ResponseError({
    domain,
    message: message || '',
    details: {
      errors: JSON.stringify(errors),
    },
  });
};
